<template>
  <div class="flex gap-4">
    <p class="px-4 text-6xl leading-[90%] text-gray-900 tracking-tighter font-bold sm:text-7xl">
      {{ marketing.headline }}
    </p>
  </div>
  <Marketing :marketing="marketing" />
  <MarketingDetails :marketingDetails="marketingDetails" />
</template>

<script>
import Marketing from "@/components/subscription/marketing/Marketing.vue";
import MarketingDetails from "@/components/subscription/marketing/MarketingDetails.vue";

export default {
  components: { MarketingDetails, Marketing },

  props: ["marketing", "marketingDetails"],
};
</script>
